import { useMutation } from "@tanstack/react-query";
import { ICancelReservationModel, ICreateReservationModel } from "../../models/ClassEvent";
import { ClassEventService } from "../../services/class-event.service";

export const useClassEventReservationMutations = () => {
  const { mutate: createReservation } = useMutation<{}, Error, ICreateReservationModel>({
    mutationFn: async (model: ICreateReservationModel) =>
      ClassEventService.createReservation(model).then((res) => res.data),
  });

  const { mutate: cancelReservation } = useMutation<any, Error, ICancelReservationModel>({
    mutationFn: async (data: ICancelReservationModel) =>
      ClassEventService.cancelReservation(data).then((res) => res.data),
  });

  return {
    createReservation,
    cancelReservation,
  };
};
